var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "#2573EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2407 23.9619C15.2431 21.8573 16.0802 19.8396 17.5684 18.3514C19.0565 16.8633 21.0742 16.0261 23.1788 16.0237V14.5117C21.0966 14.5114 19.0725 15.1988 17.4211 16.4671C15.7696 17.7353 14.5833 19.5135 14.0463 21.5253C13.5093 23.5371 13.6517 25.67 14.4514 27.5925C15.2512 29.515 16.6634 31.1197 18.4689 32.1571L19.2241 30.8462C18.0152 30.1483 17.0109 29.145 16.3117 27.9367C15.6126 26.7285 15.2433 25.3578 15.2407 23.9619ZM28.8489 23.3949V24.5289H31.873V23.3949H28.8489ZM27.8056 27.2884L30.4245 28.8004L30.9915 27.8176L28.3726 26.3055L27.8056 27.2884ZM25.5225 29.1557L27.0345 31.7745L28.0173 31.2075L26.5053 28.5887L25.5225 29.1557ZM22.6118 32.656H23.7458V29.632H22.6118V32.656ZM28.0173 16.7163L27.0345 16.1492L25.5225 18.7681L26.5053 19.3351L28.0173 16.7163ZM28.3726 21.6175L30.9915 20.1055L30.4245 19.1242L27.8056 20.6362L28.3726 21.6175ZM23.1788 17.5358C22.9783 17.5358 22.786 17.6154 22.6442 17.7572C22.5025 17.899 22.4228 18.0913 22.4228 18.2918V24.1305L20.2629 27.7306C20.1639 27.9023 20.1363 28.1059 20.1859 28.2977C20.2356 28.4896 20.3586 28.6542 20.5284 28.7563C20.6982 28.8583 20.9013 28.8896 21.094 28.8435C21.2867 28.7973 21.4536 28.6773 21.5587 28.5093L23.8267 24.7292C23.8366 24.7141 23.8365 24.696 23.8441 24.6801C23.8846 24.5879 23.9119 24.4904 23.925 24.3906C23.9258 24.3732 23.9348 24.358 23.9348 24.3399V18.2918C23.9348 18.0913 23.8552 17.899 23.7134 17.7572C23.5716 17.6154 23.3793 17.5358 23.1788 17.5358Z",
    fill: "#F7F4FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngagementIcon);
export default __webpack_public_path__ + "static/media/engagementIcon.b24daa9eac6d54c9280a18be9b66eb79.svg";
export { ForwardRef as ReactComponent };